module.exports = __webpack_public_path__ + "static/tab44-8d9b53e779da539c139d31faef71b9a2.jpg";